import React, { useEffect, useState } from 'react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/g6GHjb5UkdVuBNWsq6UHVc/Marca_con_fondo_transparente-removebg-preview.png';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-brand-cream shadow-md py-3' : 'bg-brand-cream py-5'}`} data-id="element-104">
      <div className="max-w-6xl mx-auto px-6 flex flex-col sm:flex-row justify-between items-center gap-4" data-id="element-105">
        <img src={LOGO_URL} alt="El Código del Bienestar" style={{
        width: '182px',
        height: 'auto'
      }} className="object-contain" data-id="element-106" />
        <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
        behavior: 'smooth'
      })} className="bg-brand-terracotta text-white px-6 py-2.5 rounded-full font-medium hover:bg-opacity-90 hover:scale-105 transition-all duration-300 shadow-sm" data-id="element-107">
          Quiero desintoxicar mi mente →
        </button>
      </div>
    </nav>;
}